import { render, staticRenderFns } from "./u-tabs.vue?vue&type=template&id=29b4ced5&"
import script from "./u-tabs.vue?vue&type=script&lang=js&"
export * from "./u-tabs.vue?vue&type=script&lang=js&"
import style0 from "./u-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports